/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import entityDetailsSidenavTemplate from './entity-details-sidenav.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function EntityDetailsSidenav() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            isOpen: '=',
            entityTableConfiguration: '=',
            actionDescriptors: '=',
            entityId: '=',
            onDelete: '&',
            onEntityUpdated: '&'
        },
        controller: EntityDetailsSidenavController,
        controllerAs: 'vm',
        templateUrl: entityDetailsSidenavTemplate
    };
}

/*@ngInject*/
function EntityDetailsSidenavController($scope, $window, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = vm.types.entityTypeTranslations[vm.entityType];

        vm.entity = null;
        vm.editingEntity = null;
        vm.isEdit = false;
        vm.isReadOnly = false;

        vm.onToggleEditMode = onToggleEditMode;
        vm.onCloseDetails = onCloseDetails;
        vm.saveEntity = saveEntity;
        vm.triggerResize = triggerResize;
    };

    $scope.$watch('vm.entityId', function(newVal, prevVal) {
        if (vm.entityId && !angular.equals(newVal, prevVal)) {
            reload();
        }
    });

    $scope.$on('reloadEntityDetails', () => {
        if (vm.entityId) {
            reload();
        }
    });

    function reload() {
        vm.isEdit = false;
        vm.detailsForm.$setPristine();
        loadEntity();
    }

    function loadEntity() {
        vm.entityTableConfiguration.loadEntity(vm.entityId).then(
            function success(entity) {
                if (entity) {
                    vm.entity = entity;
                    vm.editingEntity = angular.copy(vm.entity);
                    vm.isReadOnly = vm.entityTableConfiguration.detailsReadOnly(entity);
                }
            },
            function fail() {}
        );
    }

    function onToggleEditMode() {
        if (!vm.isEdit) {
            vm.detailsForm.$setPristine();
            vm.editingEntity = angular.copy(vm.entity);
        }
    }

    function onCloseDetails() {

    }

    function saveEntity() {
        $scope.$broadcast('form-submit');
        if (vm.detailsForm.$valid) {
            vm.entityTableConfiguration.saveEntity(vm.editingEntity).then(
                function success(entity) {
                    vm.entity = entity;
                    vm.detailsForm.$setPristine();
                    vm.isEdit = false;
                    vm.onEntityUpdated({entity: vm.entity});
                }
            );
        }
    }

    function triggerResize() {
        var w = angular.element($window);
        w.triggerHandler('resize');
    }

}


// WEBPACK FOOTER //
// ./src/app/table/entity-details-sidenav.directive.js